import React from 'react';
import PropTypes from 'prop-types';
import { gql } from '@common/hooks';
import { Select } from 'antd';
import { Placeholder } from '@common/components';

export function WorksUsersSelect({
  worksUsers,
  loading = false,
  size,
  ...other
}) {
  const sortedUsers =
    worksUsers &&
    [...worksUsers].sort(function (a, b) {
      var nameA = a.name.toUpperCase();
      var nameB = b.name.toUpperCase();

      if (nameA < nameB) return -1;
      if (nameA > nameB) return 1;

      return 0;
    });

  return (
    <>
      <Placeholder.Input loading={loading} size={size}>
        <Select
          className="WorksUsersSelect"
          size={size}
          showSearch={true}
          optionFilterProp="children"
          filterOption={(input, option) =>
            option.title.toLowerCase().indexOf(input.toLowerCase()) >= 0
          }
          {...other}
        >
          <Select.Option key="" value="" title="" />

          {sortedUsers &&
            sortedUsers.map(({ id, name }) => {
              return (
                <Select.Option key={id} value={id} title={name}>
                  {name}
                </Select.Option>
              );
            })}
        </Select>
      </Placeholder.Input>

      <style jsx>
        {`
          :global(.WorksUsersSelect) {
            width: 100%;
          }
        `}
      </style>
    </>
  );
}

WorksUsersSelect.propTypes = {
  loading: PropTypes.bool,
  size: PropTypes.oneOf(['large', 'middle', 'small']),
  worksUsers: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired,
    })
  ),
};

WorksUsersSelect.fragment = gql`
  fragment WorksUsersSelectFragment on WorksUser {
    id
    name
  }
`;
